import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import SearchPage from "../Page/SearchPage";
import Login from "../Page/Login";
import Ragister from "../Page/Ragister";
import Forgotpassword from "../Page/Forgotpassword";
import Otpverificationpage from "../Page/Otpverificationpage";
import ResetPassword from "../Page/Resetpaswordpage";
import Dashboard from "../comp/layout/Dashboard";
import Profile from "../Page/Profile";
import Adress from "../Page/Adress";
import Myorder from "../Page/Myorder";
import Category from "../Page/Category";
import Subcategory from "../Page/Subcategory";
import Uploadproduct from "../Page/Uploadproduct";
import ProductAdmin from "../Page/ProductAdmin";
import AdminPermission from "../comp/layout/AdminPermission";
import UserPermission from "../comp/layout/UserPermission";

// Import Appointment Pages
import AppointmentsPage from "../Page/AppointmentsPage"; // Create this file
import AppointmentManagement from "../Page/AppointmentManagement"; // Create this file for admin

// Importing extra pages from App.js
import Landingpagess from "../Component/Home/Landingpagess";
import Contact from "../Component/contact/Contact";
import Gallery from "../Component/Gallery/Gallery";
import Checkout from "../Component/Checkoutpage/Checkout";
import CreateCabinetOrder from "../Component/cabinatetotallistpage/CreateCabinetorder/Createcabinetorder";
import CabinetList from "../Component/cabinatetotallistpage/CabinetList";
import Catlog from "../Component/OurCatlog/Catlog";

// Admin pages
import Overview from "../Pages/Overview";
import Analytics from "../Pages/Analytics";
import ProductList from "../Component/Admin/ProductList";
import Sales from "../Pages/Sales";
import Payment from "../Pages/Payment";
import Refunds from "../Pages/Refunds";
import Invoice from "../Pages/Invoice";
import Returns from "../Pages/Returns";
import Notifications from "../Pages/Notifications";
import Feedback from "../Pages/Feedback";
import Setting from "../Pages/Setting";
import DarkMode from "../Pages/DarkMode";
import OrderList from "../Component/cabinatetotallistpage/CreateCabinetorder/components/OrderList";
import AdminUserManagement from "../Page/AdminUserManagement";
import PrivacyPolicy from "../Page/PrivacyPolicy";
import AboutPage from "../Component/AboutPage";
import ThankYouPage from "../Component/contact/ThankYouPage";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      // USER ROUTES
      {
        path: "",
        element: <Landingpagess />,
      },

      {
        path: "search",
        element: <SearchPage />,
      },

      {
        path: "contact",
        element: <Contact />,
      },
      {
        path: "thank-you",
        element: <ThankYouPage />, // Add this route
      },

      {
        path: "PrivacyPolicy",
        element: <PrivacyPolicy />,
      },
      {
        path: "login",
        element: <Login />,
      },
     
      {
        path: "forgot-password",
        element: <Forgotpassword />,
      },
      {
        path: "verification-otp",
        element: <Otpverificationpage />,
      },
      {
        path: "reset-password",
        element: <ResetPassword />,
      },
      {
        path: "contact",
        element: <Contact />,
      },
      {
        path: "gallery",
        element: <Gallery />,
      },
      {
        path: "About",
        element: <AboutPage />,
      },
      {
        path: "checkout",
        element: <Checkout />,
      },

      // CABINET ORDER ROUTES
      {
        path: "cl",
        element: <CabinetList />,
      },
      {
        path: "catalog",
        element: <Catlog />,
      },

      // DASHBOARD (protected section)
      {
        path: "dashboard",
        element: <Dashboard />,
        children: [
          // USER ONLY ROUTES (both user and admin can access)
          {
            path: "profile",
            element: (
              <UserPermission>
                <Profile />
              </UserPermission>
            ),
          },
          {
            path: "adress",
            element: (
              <UserPermission>
                <Adress />
              </UserPermission>
            ),
          },
          {
            path: "myorder",
            element: (
              <UserPermission>
                <Myorder />
              </UserPermission>
            ),
          },
          {
            path: "cco",
            element: (
              <UserPermission>
                <CreateCabinetOrder />
              </UserPermission>
            ),
          },
          {
            path: "saveorder",
            element: (
              <UserPermission>
                <OrderList />
              </UserPermission>
            ),
          },

          // ADMIN ONLY ROUTES

          {
            path: "AdminUserManagement",
            element: (
              <AdminPermission>
                <AdminUserManagement />
              </AdminPermission>
            ),
          },

          {
            path: "category",
            element: (
              <AdminPermission>
                <Category />
              </AdminPermission>
            ),
          },

          {
            path: "ragister",
            element: (
              <AdminPermission>
                <Ragister />
              </AdminPermission>
            ),
          },

          {
            path: "subcategory",
            element: (
              <AdminPermission>
                <Subcategory />
              </AdminPermission>
            ),
          },
          {
            path: "uploadproduct",
            element: (
              <AdminPermission>
                <Uploadproduct />
              </AdminPermission>
            ),
          },
          {
            path: "product",
            element: (
              <AdminPermission>
                <ProductAdmin />
              </AdminPermission>
            ),
          },

          // APPOINTMENT ROUTES (Admin Only)
          {
            path: "appointments",
            element: (
              <AdminPermission>
                <AppointmentsPage />
              </AdminPermission>
            ),
          },
          {
            path: "appointment-management",
            element: (
              <AdminPermission>
                <AppointmentManagement />
              </AdminPermission>
            ),
          },

          // ADMIN EXTRA ROUTES
          {
            path: "overview",
            element: (
              <AdminPermission>
                <Overview />
              </AdminPermission>
            ),
          },
          {
            path: "analytics",
            element: (
              <AdminPermission>
                <Analytics />
              </AdminPermission>
            ),
          },
          {
            path: "products",
            element: (
              <AdminPermission>
                <ProductList />
              </AdminPermission>
            ),
          },
          {
            path: "sales",
            element: (
              <AdminPermission>
                <Sales />
              </AdminPermission>
            ),
          },
          {
            path: "payment",
            element: (
              <AdminPermission>
                <Payment />
              </AdminPermission>
            ),
          },
          {
            path: "refunds",
            element: (
              <AdminPermission>
                <Refunds />
              </AdminPermission>
            ),
          },
          {
            path: "invoice",
            element: (
              <AdminPermission>
                <Invoice />
              </AdminPermission>
            ),
          },
          {
            path: "returns",
            element: (
              <AdminPermission>
                <Returns />
              </AdminPermission>
            ),
          },
          {
            path: "notifications",
            element: (
              <AdminPermission>
                <Notifications />
              </AdminPermission>
            ),
          },
          {
            path: "feedback",
            element: (
              <AdminPermission>
                <Feedback />
              </AdminPermission>
            ),
          },
          {
            path: "setting",
            element: (
              <AdminPermission>
                <Setting />
              </AdminPermission>
            ),
          },
          {
            path: "darkmode",
            element: (
              <AdminPermission>
                <DarkMode />
              </AdminPermission>
            ),
          },
        ],
      },
    ],
  },
]);

export default router;